import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { MenuList } from '@store/additional-services/additional-services.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdditionalServicesService {
  constructor(private http: HttpClient) {}

  getMenu(eventId: number): Observable<MenuList> {
    return this.http.get<MenuList>(`${environment.protocol}${environment.webApiUrl}/event/${eventId}/menu-booking`);
  }
}
